"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
var ClientBridgeFactory_1 = require("./ClientBridgeFactory");
var RawLogger_1 = require("../logging/RawLogger");
var SDKProvider = /** @class */ (function () {
    function SDKProvider() {
    }
    SDKProvider.getSDK = function (initializationParams) {
        return new Promise(function (resolve) {
            var protocolInfo = {
                hostType: initializationParams.hostType,
                protocolType: initializationParams.protocolType
            };
            var clientBridge = ClientBridgeFactory_1.default.getClientBridge(protocolInfo);
            var clientBridgeSetupParameters = {
                logger: new RawLogger_1.default(clientBridge, initializationParams.logger)
            };
            return clientBridge.setup(clientBridgeSetupParameters).then(function () {
                var clientSdk = {
                    dispose: clientBridge.dispose.bind(clientBridge),
                    id: clientBridge.id,
                    initialize: clientBridge.initialize.bind(clientBridge),
                    joinConversation: clientBridge.joinConversation.bind(clientBridge),
                    update: clientBridge.update.bind(clientBridge),
                    setDebug: clientBridge.setDebug.bind(clientBridge)
                };
                return resolve(clientSdk);
            });
        });
    };
    return SDKProvider;
}());
exports.default = SDKProvider;
//# sourceMappingURL=SDKProvider.js.map